/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcoverai3Inputs */

const en_aiflowcoverai3 = /** @type {(inputs: Aiflowcoverai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a cover designed`)
};

const de_aiflowcoverai3 = /** @type {(inputs: Aiflowcoverai3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover gestalten lassen`)
};

/**
* | output |
* | --- |
* | "Have a cover designed" |
*
* @param {Aiflowcoverai3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcoverai3 = /** @type {((inputs?: Aiflowcoverai3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcoverai3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcoverai3(inputs)
	return de_aiflowcoverai3(inputs)
});
export { aiflowcoverai3 as "aiFlowCoverAi" }